export default __webpack_public_path__ + "static/media/how-it-works-4-mob.8ce93cc4.png";